export const getModal = state => state.modal;
